// src/components/MachineTable.js
import React from 'react';
import './Blowtable.css';

const Blowtable = () => {
    const headers = [
        'Model',
        'EB30U55',
        'EB30U65',
        'EB70U70',
        'EB70U75',
        'EB70U85',
    ];

    const rows = [
        ['Max Capacity(L)', 50, 90, 126, 160, 200],
        ['Clamping Force(KN)', 265, 320, 350, 440, 490],
        ['Max Mold Size(W*H)mm', 575, 680, 750, 940, 1040],
        ['Screw Diameter(mm)', '480x480', '540x540', '610x610', '705x705', '775x755'],
        ['Screw L/D Ratio', '315x315', '360x360', '410x410', '460x460', '510x510'],
        ['Screw Rotary Speed(rpm)', 310, 360, 400, 500, 550],
        ['Extrusion Weight(HDPE)kg/hr', 110, 130, 145, 160, 230],
        ['Extrusion Motor Power(kw)', 70, 100, 100, 140, 140],
        ['Pump Motor Power(kw)', 20, 34, 42, 49, 65],
        ['Heating Power(kw)', 20, 34, 42, 49, 65],
        ['Operation Pressure(Mpa)', 20, 34, 42, 49, 65],
        ['Air Consumption(m³/min)', 20, 34, 42, 49, 65],
        ['Chilling Water Consumption(L/min)', 20, 34, 42, 49, 65],
        ['Oil Tank Capacity(L)', 20, 34, 42, 49, 65],
        ['Machine Dimension(L*W*H)mm', 20, 34, 42, 49, 65],
        ['Machine Weight(kg)', 20, 34, 42, 49, 65],

    ];

    return (
        <div className="container" style={{
            border: '1px solid lightgray',
            padding: '0px',
            marginTop: '10px'

        }}>
            <h2 className="table-heading">Clamping Unit Specifications</h2>
            <div className="responsive-table">
                <table>
                    <thead>
                        <tr>
                            {headers.map((head, index) => (
                                <th key={index} className="unit-row">{head}</th>
                            ))}
                        </tr>
                        {/* <tr>
                            <th colSpan={headers.length} className="unit-row">Clamping Unit</th>
                        </tr> */}
                    </thead>

                    <tbody>
                        {rows.map((row, i) => (
                            <tr key={i}>
                                {row.map((cell, j) => (
                                    <td key={j}>{cell}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Blowtable;
